// extracted by mini-css-extract-plugin
module.exports = {"tabs":"show_tabs_3YC4v"};